import React from "react";
import { certificatesRepository } from "../../../repository/certificates.repository";
import ListItem from "../ListItem/ListItem";
import ListItemImgInfo from "../../molecules/ListItemImgInfo/ListItemImgInfo";
import ListItemInfo from "../../molecules/ListItemInfo/ListItemInfo";
import { languages } from "../../../dummyData/dummyData";

const Certificate = ({ data, skipUser, skipTeam }) => {
  const { selectableId, course_title, course_topic, prepared_teams, course_id, profile_image_small, user, download_ready, prepared_date, isChecked } = data;

  return (
    <ListItem title={course_title} image={profile_image_small} selectableId={selectableId} isChecked={isChecked} buttons={[
      {
        icon: "download",
        onClick: () => certificatesRepository.downloadCertificate(user.username, course_id),
        disabled: !download_ready,
        tooltip: download_ready ? `${languages.EN.labels.download} ${languages.EN.labels.certificate}` : languages.EN.labels.certificateBeingGenerated,
      },
    ]}>
      <ListItemInfo value={languages.EN.enums.learningAreas[course_topic]} />
      {!skipUser && <ListItemImgInfo value={`${user.profile.name} ${user.profile.surname}`} image={user.profile.profile_image_small} />}
      {!skipUser && <ListItemInfo value={user.profile.user_job_position?.name} />}
      {!skipTeam && <ListItemInfo value={prepared_teams} />}
      <ListItemInfo value={prepared_date} />
    </ListItem>
  );
};

export default Certificate;
